module.exports = __webpack_public_path__ + "static/media/Triforce.3f12e73c.png";